import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import * as S from './VariantPurchase.style';
import QuantityGroup from './QuantityGroup';
import StockAndShipping from './StockAndShipping';
import VariantPricing from '@modules/product/component/variant-pricing/VariantPricing';
import type Product from '@modules/product/type/product';

const VariantPurchase = ({
    whereToBuyEnabled,
    onClickWhereToBuy,
    product,
}: {
    whereToBuyEnabled?: boolean;
    onClickWhereToBuy?: () => void;
    product: Product;
}) => {
    const { css } = useStyles();
    const { desktop } = useAppDisplayModeContext();

    return (
        <div className={css(S.VariantPurchase)}>
            <div className="flex flex-col gap-4">
                {desktop && (
                    <VariantPricing pricingType={product.Pricing.PricingType} />
                )}
                <StockAndShipping />
            </div>
            <QuantityGroup
                whereToBuyEnabled={whereToBuyEnabled}
                onClickWhereToBuy={onClickWhereToBuy}
            />
        </div>
    );
};

export default VariantPurchase;
